export function quantityButton(fieldId: string, valueStr: string, maxStr: string) {
    const containerEle = document.getElementById('container_' + fieldId);
    const inputEle = document.getElementById('input_' + fieldId);
    const inputDescEle = document.getElementById('input_decrease_' + fieldId);
    const inputIncEle = document.getElementById('input_increase_' + fieldId);
    var dataEle = document.getElementById('data_' + fieldId);

    const value = parseInt(valueStr);
    const max = parseInt(maxStr);

    dataEle.innerHTML = valueStr;

    (inputDescEle as HTMLInputElement).disabled = value <= 0;
    (inputIncEle as HTMLInputElement).disabled = value >= max;

    if (containerEle.getAttribute('data-quantitybutton')) {
        return;
    }

    containerEle.setAttribute('data-quantitybutton', 'true');

    inputDescEle.onclick = () => {
        const valDesc = dataEle.innerHTML.trim().replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
            .replace(/"/g, "&quot;")
            .replace(/'/g, "&#039;");
        inputEle.setAttribute('value', (parseInt(valDesc) - 1).toString());
        ((window as any).htmx as any).trigger('#updatebutton', 'click');
    }

    inputIncEle.onclick = () => {
        const valInc = dataEle.innerHTML.trim().replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
            .replace(/"/g, "&quot;")
            .replace(/'/g, "&#039;");
        inputEle.setAttribute('value', (parseInt(valInc) + 1).toString());
        ((window as any).htmx as any).trigger('#updatebutton', 'click');
    }

    containerEle.style.display = null;
}
